/** Shared react-select styles (ICS green focus ring). */
export function buildAutocompleteSelectStyles({ isInvalid = false, compact = false } = {}) {
  return {
    control: (base, state) => ({
      ...base,
      minHeight: compact ? 32 : 38,
      fontSize: compact ? 13 : base.fontSize,
      borderColor: isInvalid
        ? "#dc3545"
        : state.isFocused
          ? "#93ab3c"
          : base.borderColor,
      boxShadow: state.isFocused
        ? isInvalid
          ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
          : "0 0 0 0.2rem rgba(147, 171, 60, 0.25)"
        : base.boxShadow,
      "&:hover": {
        borderColor: isInvalid ? "#dc3545" : state.isFocused ? "#93ab3c" : "#ced4da",
      },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    valueContainer: (base) => ({
      ...base,
      padding: compact ? "0 6px" : base.padding,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: compact ? 30 : base.height,
    }),
  };
}
